import './collapse-styles.css.js';
import { useClassNames } from '@magnetic/hooks';
import { List } from '@magnetic/icons';
import { Tooltip } from '@magnetic/tooltip';
import React, { forwardRef } from 'react';
import { useNavContext } from '../nav-context.js';
import { NavCollapseAuto } from './auto.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const RenderNavCollapse = /* @__PURE__ */ __name(({ auto, className, ...props }, ref) => {
  const { isCollapsed, isDrawerOpen, isIconOnly, navZIndex, toggleCollapsed } = useNavContext();
  const classNames = useClassNames(className, "mds-rebuild-nav-collapse", {
    "mds-rebuild-nav-collapse-collapsed": isCollapsed && !isIconOnly,
    "mds-rebuild-nav-collapse-icon-only": isCollapsed && isIconOnly
  });
  if (auto) {
    return /* @__PURE__ */ React.createElement(NavCollapseAuto, {
      auto
    });
  }
  return /* @__PURE__ */ React.createElement(Tooltip, {
    disabled: isCollapsed && isDrawerOpen,
    style: navZIndex ? { zIndex: navZIndex + 1 } : void 0,
    title: isCollapsed ? "Expand" : "Collapse"
  }, /* @__PURE__ */ React.createElement("button", {
    "aria-controls": "site-nav-wrapper",
    "aria-label": "Resize Site Navigation",
    className: classNames,
    onClick: toggleCollapsed,
    ref,
    type: "button",
    ...props
  }, /* @__PURE__ */ React.createElement(List, {
    size: 24
  })));
}, "RenderNavCollapse");
const NavCollapse = forwardRef(RenderNavCollapse);
NavCollapse.displayName = "Nav.Collapse";

export { NavCollapse };
//# sourceMappingURL=index.js.map
